import React from 'react';

interface ComponentGateProps {
  children: React.ReactElement;
  componentType?: string;
  typeList: string[];
}

/**
 * @author Jungwirth
 */
export const ComponentGate: React.FC<ComponentGateProps> = (props: Readonly<ComponentGateProps>): JSX.Element | null => {
  const { children, typeList, componentType } = props;

  const isNotVisible: boolean = componentType === undefined || !typeList.includes(componentType);

  if (isNotVisible) {
    return null;
  }

  return children;
};
